import BaseApi from './baseApi';
import IOutbound from '../models/IOutbound';
import IAuthentication from '../models/IAuthentication';
export default class OutboundApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Outbounds");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetOutbounds(idCompany: string) : Promise<IOutbound[]> {
        let json : string = "";
        if (idCompany === "00000000-0000-0000-0000-000000000000") {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithIdCompany(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outbounds: IOutbound[] = [];
            outbounds = response.data as IOutbound[];
            return outbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetOutboundsSubstractMonth(idCompany: string) : Promise<IOutbound[]> {
        let json : string = "";
        if (idCompany === "00000000-0000-0000-0000-000000000000") {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithIdCompanyAndDate(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outbounds: IOutbound[] = [];
            outbounds = response.data as IOutbound[];
            return outbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetOutboundsCompleted(idCompany: string) : Promise<IOutbound[]> {
        let json : string = "";
        if (idCompany === "00000000-0000-0000-0000-000000000000") {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithOnlyCompleted(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outbounds: IOutbound[] = [];
            outbounds = response.data as IOutbound[];
            return outbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveOutbound(outbound: IOutbound) : Promise<string> {
        const json = this.getJsonSave(outbound);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateOutbound(outbound: IOutbound) : Promise<boolean> {
        const json = this.getJsonUpdate(outbound);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteOutbound(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async GetOutboundsByDate(time: string) : Promise<IOutbound[]> {
        let json : string = this.getJsonReadByTimeSlot(time);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outbounds: IOutbound[] = [];
            outbounds = response.data as IOutbound[];
            return outbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetOutboundsCodes(idCompany: string) : Promise<IOutbound[]> {
        let json : string = this.getJsonReadOutboundsCodes(idCompany);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outbounds: IOutbound[] = [];
            outbounds = response.data as IOutbound[];
            return outbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    private getJsonReadOutboundsCodes(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Outbounds",
                "Item2": "id"
            }, {
                "Item1": "Outbounds",
                "Item2": "code"
            }],
            "tables": [{
                "Item1": "Outbounds"
            }],
            "conditions": [{
                "Item1": "Outbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "(Outbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "Outbounds",
                "Item2": "Id",
                "Item3": "IN",
                "Item4": "(SELECT IdOutbound FROM OutboundsDeliveryNotes WHERE IdWarehouse IN (SELECT IdWarehouse FROM WarehousesShared WHERE idWarehouse = OutboundsDeliveryNotes.IdWarehouse) AND Deleted = 0)",
                "Item5": "OR"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }

    private getJsonReadByTimeSlot(time: string) : any {
        const json = {
            "fields": [{
                "Item1": "Outbounds",
                "Item2": "id"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusOutbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Outbounds",
                "Item2": "code"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateOut"
            }, {
                "Item1": "Outbounds",
                "Item2": "dossierNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "grnNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "weight"
            }, {
                "Item1": "Outbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "deliveriesNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "description"
            }, {
                "Item1": "Outbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Outbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Outbounds",
                "Item2": "agp"
            }, {
                "Item1": "Outbounds",
                "Item2": "referenceInboundCode"
            }],
            "tables": [{
                "Item1": "Outbounds"
            }, {
                "Item1": "Customers"
            }],
            "joins": [{
                "Item1": "Outbounds",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Outbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateOut",
                "Item3": "=",
                "Item4": time
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "Outbounds",
            "conditions": [{
                "Item1": "Outbounds",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(Outbound: IOutbound) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idCompanySource",
                "Item2": Outbound.idCompanySource
            }, {
                "Item1": "idCompanyDestination",
                "Item2": Outbound.idCompanyDestination
            }, {
                "Item1": "idCustomer",
                "Item2": Outbound.idCustomer
            }, {
                "Item1": "idStatus",
                "Item2": Outbound.idStatus
            }, {
                "Item1": "code",
                "Item2": Outbound.code
            }, {
                "Item1": "dateOut",
                "Item2": Outbound.dateOut
            }, {
                "Item1": "dossierNumber",
                "Item2": Outbound.dossierNumber
            }, {
                "Item1": "grnNumber",
                "Item2": Outbound.grnNumber
            }, {
                "Item1": "sealNumber",
                "Item2": Outbound.sealNumber
            }, {
                "Item1": "weight",
                "Item2": Outbound.weight
            }, {
                "Item1": "containerNumber",
                "Item2": Outbound.containerNumber
            }, {
                "Item1": "deliveriesNumber",
                "Item2": Outbound.deliveriesNumber
            }, {
                "Item1": "description",
                "Item2": Outbound.description
            }, {
                "Item1": "orderNumber",
                "Item2": Outbound.orderNumber
            }, {
                "Item1": "StartTime",
                "Item2": Outbound.startTime
            }, {
                "Item1": "EndTime",
                "Item2": Outbound.endTime
            }, {
                "Item1": "DateChanged",
                "Item2": Outbound.dateChanged
            }, {
                "Item1": "entrepot",
                "Item2": Outbound.entrepot
            }, {
                "Item1": "agp",
                "Item2": Outbound.agp
            }, {
                "Item1": "referenceInboundCode",
                "Item2": Outbound.referenceInboundCode
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "Outbounds"
        };
        return json;
    }

    private getJsonUpdate(Outbound: IOutbound) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idCompanySource",
                "Item2": Outbound.idCompanySource
            }, {
                "Item1": "idCompanyDestination",
                "Item2": Outbound.idCompanyDestination
            }, {
                "Item1": "idCustomer",
                "Item2": Outbound.idCustomer
            }, {
                "Item1": "idStatus",
                "Item2": Outbound.idStatus
            }, {
                "Item1": "code",
                "Item2": Outbound.code
            }, {
                "Item1": "dateOut",
                "Item2": Outbound.dateOut
            }, {
                "Item1": "dossierNumber",
                "Item2": Outbound.dossierNumber
            }, {
                "Item1": "grnNumber",
                "Item2": Outbound.grnNumber
            }, {
                "Item1": "sealNumber",
                "Item2": Outbound.sealNumber
            }, {
                "Item1": "weight",
                "Item2": Outbound.weight
            }, {
                "Item1": "containerNumber",
                "Item2": Outbound.containerNumber
            }, {
                "Item1": "deliveriesNumber",
                "Item2": Outbound.deliveriesNumber
            }, {
                "Item1": "description",
                "Item2": Outbound.description
            }, {
                "Item1": "orderNumber",
                "Item2": Outbound.orderNumber
            }, {
                "Item1": "StartTime",
                "Item2": Outbound.startTime
            }, {
                "Item1": "EndTime",
                "Item2": Outbound.endTime
            }, {
                "Item1": "DateChanged",
                "Item2": Outbound.dateChanged
            }, {
                "Item1": "Entrepot",
                "Item2": Outbound.entrepot
            }, {
                "Item1": "Agp",
                "Item2": Outbound.agp
            }, {
                "Item1": "ReferenceInboundCode",
                "Item2": Outbound.referenceInboundCode
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "Outbounds",
            "keyvalue": Outbound.id
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "Outbounds",
                "Item2": "id"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusOutbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Outbounds",
                "Item2": "code"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateOut"
            }, {
                "Item1": "Outbounds",
                "Item2": "dossierNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "grnNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "weight"
            }, {
                "Item1": "Outbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "deliveriesNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "description"
            }, {
                "Item1": "Outbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Outbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Outbounds",
                "Item2": "agp"
            }, {
                "Item1": "Outbounds",
                "Item2": "referenceInboundCode"
            }],
            "tables": [{
                "Item1": "Outbounds"
            }, {
                "Item1": "Customers"
            }],
            "joins": [{
                "Item1": "Outbounds",
                "Item2": "idCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Outbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Outbounds",
                "Item2": "idStatus",
                "Item3": "NOT IN",
                "Item4": "(SELECT ID FROM ListStatusOutbounds WHERE Name = 'Completed')"
            }]
        };
        return json;
    }

    private getJsonReadWithIdCompany(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Outbounds",
                "Item2": "id"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusOutbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Outbounds",
                "Item2": "code"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateOut"
            }, {
                "Item1": "Outbounds",
                "Item2": "dossierNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "grnNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "weight"
            }, {
                "Item1": "Outbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "deliveriesNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "description"
            }, {
                "Item1": "Outbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Outbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Outbounds",
                "Item2": "agp"
            }, {
                "Item1": "Outbounds",
                "Item2": "referenceInboundCode"
            }],
            "tables": [{
                "Item1": "Outbounds"
            }, {
                "Item1": "Customers"
            }],
            "joins": [{
                "Item1": "Outbounds",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Outbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Outbounds",
                "Item2": "idStatus",
                "Item3": "NOT IN",
                "Item4": "(SELECT ID FROM ListStatusOutbounds WHERE Name = 'Completed')",
                "Item5": "AND"
            }, {
                "Item1": "(Outbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }

    private getJsonReadWithIdCompanyAndDate(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Outbounds",
                "Item2": "id"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusOutbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Outbounds",
                "Item2": "code"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateOut"
            }, {
                "Item1": "Outbounds",
                "Item2": "dossierNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "grnNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "weight"
            }, {
                "Item1": "Outbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "deliveriesNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "description"
            }, {
                "Item1": "Outbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Outbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Outbounds",
                "Item2": "agp"
            }, {
                "Item1": "Outbounds",
                "Item2": "referenceInboundCode"
            }],
            "tables": [{
                "Item1": "Outbounds"
            }, {
                "Item1": "Customers"
            }],
            "joins": [{
                "Item1": "Outbounds",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Outbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateOut",
                "Item3": ">",
                "Item4": this.subtractMonths(1),
                "Item5": "AND"
            }, {
                "Item1": "(Outbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }

    private subtractMonths(numOfMonths: number, date = new Date()) {
        date.setMonth(date.getMonth() - numOfMonths);
        return date;
    }

    private getJsonReadWithOnlyCompleted(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Outbounds",
                "Item2": "id"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusOutbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Outbounds",
                "Item2": "code"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateOut"
            }, {
                "Item1": "Outbounds",
                "Item2": "dossierNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "grnNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "weight"
            }, {
                "Item1": "Outbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "deliveriesNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "description"
            }, {
                "Item1": "Outbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Outbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Outbounds",
                "Item2": "agp"
            }, {
                "Item1": "Outbounds",
                "Item2": "referenceInboundCode"
            }],
            "tables": [{
                "Item1": "Outbounds"
            }, {
                "Item1": "Customers"
            }],
            "joins": [{
                "Item1": "Outbounds",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Outbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Outbounds",
                "Item2": "idStatus",
                "Item3": "IN",
                "Item4": "(SELECT ID FROM ListStatusOutbounds WHERE Name = 'Completed')",
                "Item5": "AND"
            }, {
                "Item1": "(Outbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }
}
